(() => {
  const COOKIE_NAME = 'site_image_popup_closed';

  function hasSessionCookie() {
    return document.cookie.split('; ').some((cookie) => cookie.startsWith(`${COOKIE_NAME}=`));
  }

  function setSessionCookie() {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${COOKIE_NAME}=1; path=/; SameSite=Lax${secure}`;
  }

  function closePopup(popup) {
    popup.hidden = true;
    popup.classList.remove('is-visible');
    setSessionCookie();
  }

  function openPopup(popup) {
    popup.hidden = false;
    requestAnimationFrame(() => popup.classList.add('is-visible'));
  }

  function initPopup() {
    const popup = document.querySelector('[data-site-image-popup]');
    if (!popup || hasSessionCookie()) return;

    popup.querySelectorAll('[data-site-image-popup-close]').forEach((element) => {
      element.addEventListener('click', () => closePopup(popup));
    });

    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup(popup);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) closePopup(popup);
    });

    openPopup(popup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopup);
  } else {
    initPopup();
  }
})();
